var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"page-header"},[_vm._v("Page Not Found")]),_vm._v("\n  The requested page was not found. Please check the URL and/or return\n  "),_c('router-link',{attrs:{"to":"/"}},[_vm._v("home")]),_vm._v(".\n")],1)}
var staticRenderFns = []

export { render, staticRenderFns }